export const RECAPTCHA_ACTIONS = {
  salesLead: 'sales_lead_submit',
  dynamicLead: 'dynamic_lead_submit',
  tradeEnquiry: 'trade_enquiry_submit',
} as const;
